'use client';

import { type Listing, type WithID } from '@ps/models';

import { ProductImageCarousel } from '../../pdp/components/ProductImageCarousel';
import { usePdpWearWithAi } from './PdpWearWithAiSlots';

/**
 * Client wrapper around `ProductImageCarousel` that integrates the
 * Wear-With-AI surfaces:
 *  - Merges the creator's API-fetched AI media (or the listing's
 *    curated `defaultWearWithAiMedia`/`extraWearWithAiMedias` for
 *    viewers) into the carousel as extra slides.
 *  - Mounts the green "Wear with AI" CTA as `floatingActions`.
 *  - Overlays favorite + visibility chips on the active slide when
 *    it's the creator's own AI-generated media (creator-only).
 *
 * 1:1 with legacy `ListingImageContainer.tsx` + the wired AffiliateOverlay
 * combo.
 */
export function PdpHero({
  listing,
  sellerId,
  name,
}: {
  listing: WithID<Listing>;
  sellerId: string;
  name: string;
}) {
  const { cta, media, slideOverlay } = usePdpWearWithAi({
    listing,
    sellerId,
  });
  return (
    <ProductImageCarousel
      media={media}
      name={name}
      floatingActions={cta}
      slideOverlay={slideOverlay}
    />
  );
}
